import {NoJobFound} from '@jobseeker/lotus/assets/images';
import Button from '@jobseeker/lotus/elements/ButtonV2';
import {useWrappedTheme} from '@jobseeker/lotus/hooks';
import {Box, Typography} from '@mui/material';
import Image from 'next/image';
import Link from 'next/link';

const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

function Index({
  clearFilter,
  showBadge,
  source,
  allowedHeight = '80vh',
}: {
  clearFilter: () => void;
  showBadge: boolean;
  source?: string;
  allowedHeight?: string;
}) {
  const MESSAGE_BASED_SOURCE: {[key: string]: string} = {
    'applied-jobs': 'Try modifying the filters for better results.',
    'ea-listing': 'No recent jobs found for your criteria.',
  };
  const theme = useWrappedTheme();

  return (
    <>
      {isAppIimjobs ? (
        <Box
          height={allowedHeight}
          display={source == 'applied-jobs' ? 'block' : 'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          marginTop={source == 'applied-jobs' ? 7 : 0}
        >
          <Box
            display={'flex'}
            flexDirection={'column'}
            justifyContent={'center'}
            alignItems={'center'}
            px={{xxs: 2, md: 3}}
          >
            <Image
              src={NoJobFound}
              alt={'JobTagsEmpty'}
              width={179}
              height={179}
              object-fit="contain"
            />
            <Typography
              mt={3}
              fontSize={{xxs: 16, lg: 18}}
              color="secondary.dark"
              variant="subtitle1"
            >
              {'No results found'}&nbsp;
            </Typography>
            <Typography color={'text.secondary'} variant="subtitle3" mt={0.5}>
              {source && MESSAGE_BASED_SOURCE[source]
                ? MESSAGE_BASED_SOURCE[source]
                : 'Try again using a different filter to receive the most relevant job.'}
            </Typography>
            {showBadge && (
              <Button
                sx={{
                  width: {lg: '125px'},
                  background: '#000',
                  mt: {xxs: 1, md: 2},
                  px: 2,
                  py: 1,
                  height: 'fit-content',
                  backgroundColor: 'secondary.main',
                }}
                variant="contained"
                size="large"
                onClick={clearFilter}
              >
                Clear Filter
              </Button>
            )}
          </Box>
        </Box>
      ) : (
        <Box mt={8}>
          {source == 'applied-jobs' ? (
            <h1 style={{fontSize: 24, fontWeight: 600, textAlign: 'center'}}>
              You Don't Have Applied Jobs
            </h1>
          ) : source == 'ea-listing' ? (
            <h1 style={{fontSize: 14, fontWeight: 600, textAlign: 'center'}}>
              No jobs have been posted recently for above criteria.
              <br></br>
              You may{' '}
              <Link
                href="/subscribe/early-applicant"
                style={{
                  color: theme.palette.primary.main,
                  textDecoration: 'underline',
                }}
              >
                Review the Preferences
              </Link>{' '}
              you have added
            </h1>
          ) : (
            <h1 style={{fontSize: 24, fontWeight: 600, textAlign: 'center'}}>
              {'Sorry, No result found :('}
              <br></br>
              To get results, Please change your search criteria or filters like
              posting range from the above.
            </h1>
          )}
          <Image
            src="https://job-static.hirist.com/V8/static/media/no-jobfeed.7771e408.svg"
            alt="NoNotifications"
            width={350}
            height={400}
            style={{
              objectFit: 'contain',
              width: '70%',
              height: '70%',
              marginLeft: '15%',
            }}
          />
        </Box>
      )}
    </>
  );
}

export default Index;
